import { useEffect } from "react";

import { ErrorOptions } from "./types";

function useError({
  registrationError,
  formValues,
  setFormValues
}: ErrorOptions): void {
  useEffect(() => {
    if (registrationError) {
      setFormValues({
        ...formValues,
        errors: {
          ...formValues.errors,
          ...registrationError
        }
      });
    }
  }, [registrationError]);
}

export default useError;
